class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {

    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    let titleProduct = null;
    let numberDrop = null;
    let urlDrop = null;
    let urlCoordColor = null;

    if (parsedState.properties["COORDINATES"]) {
      const nameCoordColor = parsedState.properties["PRINT COLOUR"];

      titleProduct = parsedState.product_title.split(":")[0].split(" ");
      numberDrop = titleProduct[0] + titleProduct[1];

      const modelUrl = getModelConfig(MODEL_CONFIG)?.modelUrl || [];
      const convertName = CONVERT_DROP_NAME(numberDrop);

      urlDrop = modelUrl.find(
        (e) => e.name.toLowerCase() == convertName.toLowerCase()
      );
      
      if(urlDrop?.items){
        urlCoordColor = urlDrop.items.find(
          (e) => e.name.toLowerCase() == nameCoordColor.toLowerCase()
        );
  
        $("#cart-notification")
          .find(".cart-notification-product__image img")
          .prop("src", urlCoordColor?.url);
      }
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure
        ? disclosure.querySelector('summary')
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
